import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Download, Eye, Mail, CheckCircle, X, ArrowLeft, Filter } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
export function EventsRegistrations() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [eventFilter, setEventFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const registrations = [{
    id: 1,
    name: 'Ahmad Rizki',
    email: 'ahmad@example.com',
    event: 'Workshop React',
    eventId: 1,
    status: 'Dikonfirmasi',
    date: '2 jam lalu',
    phone: '081234567890'
  }, {
    id: 2,
    name: 'Siti Rahayu',
    email: 'siti@example.com',
    event: 'Seminar AI & ML',
    eventId: 2,
    status: 'Dikonfirmasi',
    date: '5 jam lalu',
    phone: '081234567891'
  }, {
    id: 3,
    name: 'Budi Hartono',
    email: 'budi@example.com',
    event: 'Workshop React',
    eventId: 1,
    status: 'Menunggu',
    date: '1 hari lalu',
    phone: '081234567892'
  }, {
    id: 4,
    name: 'Dewi Lestari',
    email: 'dewi@example.com',
    event: 'Meetup Bulanan',
    eventId: 3,
    status: 'Dikonfirmasi',
    date: '2 hari lalu',
    phone: '081234567893'
  }];
  const filteredRegistrations = registrations.filter(reg => {
    const matchesSearch = reg.name.toLowerCase().includes(searchQuery.toLowerCase()) || reg.email.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesEvent = eventFilter === 'all' || reg.event === eventFilter;
    const matchesStatus = statusFilter === 'all' || reg.status === statusFilter;
    return matchesSearch && matchesEvent && matchesStatus;
  });
  const handleConfirm = (id: number) => {
    if (confirm('Konfirmasi pendaftaran ini?')) {
      alert(`Pendaftaran #${id} telah dikonfirmasi`);
    }
  };
  const handleReject = (id: number) => {
    const reason = prompt('Alasan penolakan:');
    if (reason) {
      alert(`Pendaftaran #${id} ditolak. Alasan: ${reason}`);
    }
  };
  const handleSendEmail = (email: string) => {
    alert(`Mengirim email ke ${email}`);
  };
  const handleExport = () => {
    alert('Mengekspor daftar pendaftaran...');
  };
  return <div className="min-h-screen bg-white" data-id="element-2810">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2811">
        {/* Header */}
        <div className="mb-8" data-id="element-2812">
          <Button variant="ghost" onClick={() => navigate('/events/coordinator/dashboard')} className="mb-4" data-id="element-2813">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2814" />
            Kembali ke Dasbor
          </Button>
          <div className="flex items-center justify-between" data-id="element-2815">
            <div data-id="element-2816">
              <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2817">
                Pendaftaran Acara
              </h1>
              <p className="text-neutral-600" data-id="element-2818">
                Kelola pendaftaran dan peserta acara
              </p>
            </div>
            <Button variant="secondary" onClick={handleExport} data-id="element-2819">
              <Download className="w-4 h-4 mr-2" data-id="element-2820" />
              Export Daftar
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-2821">
          {[{
          label: 'Total Pendaftaran',
          value: registrations.length
        }, {
          label: 'Dikonfirmasi',
          value: registrations.filter(r => r.status === 'Dikonfirmasi').length
        }, {
          label: 'Menunggu',
          value: registrations.filter(r => r.status === 'Menunggu').length
        }, {
          label: 'Hari Ini',
          value: '2'
        }].map((stat, i) => <Card key={i} data-id="element-2822">
              <CardContent className="p-6" data-id="element-2823">
                <p className="text-2xl font-semibold text-neutral-900" data-id="element-2824">
                  {stat.value}
                </p>
                <p className="text-sm text-neutral-600" data-id="element-2825">{stat.label}</p>
              </CardContent>
            </Card>)}
        </div>

        {/* Filters */}
        <Card className="mb-6" data-id="element-2826">
          <CardContent className="p-6" data-id="element-2827">
            <div className="flex flex-col md:flex-row gap-4" data-id="element-2828">
              <div className="flex-1 relative" data-id="element-2829">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400" data-id="element-2830" />
                <Input className="pl-10" placeholder="Cari nama atau email..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-2831" />
              </div>
              <select className="h-9 rounded-lg border border-neutral-300 bg-white px-4 text-sm" value={eventFilter} onChange={e => setEventFilter(e.target.value)} data-id="element-2832">
                <option value="all" data-id="element-2833">Semua Acara</option>
                <option value="Workshop React" data-id="element-2834">Workshop React</option>
                <option value="Seminar AI & ML" data-id="element-2835">Seminar AI & ML</option>
                <option value="Meetup Bulanan" data-id="element-2836">Meetup Bulanan</option>
              </select>
              <select className="h-9 rounded-lg border border-neutral-300 bg-white px-4 text-sm" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} data-id="element-2837">
                <option value="all" data-id="element-2838">Semua Status</option>
                <option value="Dikonfirmasi" data-id="element-2839">Dikonfirmasi</option>
                <option value="Menunggu" data-id="element-2840">Menunggu</option>
              </select>
            </div>
          </CardContent>
        </Card>

        {/* Table */}
        <Card data-id="element-2841">
          <CardContent className="p-0" data-id="element-2842">
            <Table data-id="element-2843">
              <TableHeader data-id="element-2844">
                <TableRow data-id="element-2845">
                  <TableHead data-id="element-2846">Nama</TableHead>
                  <TableHead data-id="element-2847">Email</TableHead>
                  <TableHead data-id="element-2848">Telepon</TableHead>
                  <TableHead data-id="element-2849">Acara</TableHead>
                  <TableHead data-id="element-2850">Status</TableHead>
                  <TableHead data-id="element-2851">Terdaftar</TableHead>
                  <TableHead className="text-right" data-id="element-2852">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-2853">
                {filteredRegistrations.map(reg => <TableRow key={reg.id} data-id="element-2854">
                    <TableCell className="font-medium text-neutral-900" data-id="element-2855">
                      {reg.name}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2856">
                      {reg.email}
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2857">
                      {reg.phone}
                    </TableCell>
                    <TableCell className="text-neutral-900" data-id="element-2858">
                      {reg.event}
                    </TableCell>
                    <TableCell data-id="element-2859">
                      <Badge variant={reg.status === 'Dikonfirmasi' ? 'success' : 'warning'} data-id="element-2860">
                        {reg.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600" data-id="element-2861">
                      {reg.date}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-2862">
                      <div className="flex justify-end gap-2" data-id="element-2863">
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/events/${reg.eventId}/registrations/${reg.id}`)} data-id="element-2864">
                          <Eye className="w-4 h-4" data-id="element-2865" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleSendEmail(reg.email)} data-id="element-2866">
                          <Mail className="w-4 h-4" data-id="element-2867" />
                        </Button>
                        {reg.status === 'Menunggu' && <>
                            <Button size="sm" variant="ghost" className="text-success hover:text-success" onClick={() => handleConfirm(reg.id)} data-id="element-2868">
                              <CheckCircle className="w-4 h-4" data-id="element-2869" />
                            </Button>
                            <Button size="sm" variant="ghost" className="text-error hover:text-error" onClick={() => handleReject(reg.id)} data-id="element-2870">
                              <X className="w-4 h-4" data-id="element-2871" />
                            </Button>
                          </>}
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {filteredRegistrations.length === 0 && <div className="text-center py-12" data-id="element-2872">
            <Users className="w-16 h-16 text-neutral-300 mx-auto mb-4" data-id="element-2873" />
            <h3 className="text-lg font-semibold text-neutral-900 mb-2" data-id="element-2874">
              Tidak ada pendaftaran ditemukan
            </h3>
            <p className="text-neutral-600" data-id="element-2875">
              Coba ubah filter atau kata kunci pencarian
            </p>
          </div>}
      </div>
    </div>;
}